import { Alert } from '@mui/material'
import Title from './../Components/Title'
import SearchBar from '../Components/SearchBar'
import GeoMap from '../Components/GeoMap'
import { useSelector } from 'react-redux'
import SimpleWhiteBox from '../Components/SimpleWhiteBox'

export default function Map(){

  const favuriteCity = useSelector(state => state.favuriteCity).list

  return (
    <div>
      <SearchBar />
      <div className="container">
        <Title title="Mappa" />
        <p className='text-muted'>Clicca su una delle tue città preferite per visualizzarne il meteo</p>
        <SimpleWhiteBox content={
          <div style={{ height: '500px', position:'sticky' }}>
            <GeoMap cityes={favuriteCity} activeLink={true}/>
          </div>}
        />
        
        <div style={{display:'block', height:'70px'}} ></div>
        
      </div>
    </div>
  )
}